// extracted by mini-css-extract-plugin
export default {"table":"FPWuMHM0SKKLwDSvVSPs","actions":"VkHx_kQASX_HHLzGrTlP"};
    if(module.hot) {
      // 1647894309389
      var cssReload = require("../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  